import { Fragment, FunctionComponent } from 'react'
import Navbar from '@/components/Navbar'
import { useStyles } from '@/components/LoadingPage/styles'
import { LoadingPageProps } from './types'
import { Text } from '@conexasaude/conexa-hero'
import { RenderIf } from '../RenderIf'

const LoadingPage: FunctionComponent<LoadingPageProps> = ({
  withoutNav,
  text,
  useNeutralColor,
}) => {
  const styles = useStyles({ useNeutralColor })
  return (
    <Fragment>
      <RenderIf condition={!withoutNav}>
        <Navbar />
      </RenderIf>
      <div css={styles.containerLoading}>
        <div css={styles.loading} />
        <Text variant="headingMedium" css={styles.auxiliaryText}>
          {text}
        </Text>
      </div>
    </Fragment>
  )
}

export default LoadingPage
